import { render, staticRenderFns } from "./ImagePaster.vue?vue&type=template&id=146aae26&scoped=true"
import script from "./ImagePaster.vue?vue&type=script&lang=js"
export * from "./ImagePaster.vue?vue&type=script&lang=js"
import style0 from "./ImagePaster.vue?vue&type=style&index=0&id=146aae26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146aae26",
  null
  
)

export default component.exports